import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareLinesBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareLinesBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM6 14.5H13V16H6V14.5ZM15 14.5H18V16H15V14.5ZM6 10.5V12H9V10.5H6ZM11 10.5V12H18V10.5H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareLinesBottom;
